import React from 'react';
import ReactDOM from 'react-dom';

import registerServiceWorker from './registerServiceWorker';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import reducers from './Reducers/index';
import { Provider } from 'react-redux';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import LoadingComponent from './Containers/LoadingComponent';
import AuthenticatedComponent from './Containers/AuthenticatedComponent';



import about from "./Containers/about"

import lawfirm from "./Containers/lawfirm";
import chinapractice from "./Containers/chinapractice";
import  contact from "./Containers/contact";
import businesslitigation from "./Containers/businesslitigation"
import iplitigation from "./Containers/iplitigation"
import criminaldefense from "./Containers/criminaldefense"
import outsidegc from "./Containers/outsidegc"
import probono from "./Containers/probono"
import tradesecrets from "./Containers/tradesecrets"
import team from "./Containers/team";
import news from "./Containers/news"
const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);

ReactDOM.render(
  <Provider store={createStoreWithMiddleware(reducers)}>
    <BrowserRouter>
      <LoadingComponent>
        <Switch>



            <Route path="/probono" component={probono}/>
            <Route path="/about" component={about}/>
            <Route path="/chinapractice" component={chinapractice}/>
            <Route path="/team" component={team}/>
            <Route path="/businesslitigation" component={businesslitigation}/>
            <Route path="/tradesecrets" component={tradesecrets}/>
            <Route path="/iplitigation" component={iplitigation}/>
            <Route path="/criminaldefense" component={criminaldefense}/>
            <Route path="/outsidegc" component={outsidegc}/>
            <Route path="/contact" component={contact}/>
            <Route path="/probono" component={probono}/>
            <Route path="/home" component={lawfirm}/>
            <Route path="/news" component={news}/>
            <Route path="/" component={lawfirm}/>

          <AuthenticatedComponent>


              <Route path="/" component={lawfirm}/>



          </AuthenticatedComponent>
        </Switch>
      </LoadingComponent>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js